import { render } from "./ChartMessage.vue?vue&type=template&id=9c19bba8"
import script from "./ChartMessage.vue?vue&type=script&lang=ts"
export * from "./ChartMessage.vue?vue&type=script&lang=ts"
script.render = render

export default script